import { render, staticRenderFns } from "./HubContentMessage.vue?vue&type=template&id=112bd46f"
import script from "./HubContentMessage.vue?vue&type=script&lang=js"
export * from "./HubContentMessage.vue?vue&type=script&lang=js"
import style0 from "./HubContentMessage.vue?vue&type=style&index=0&id=112bd46f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports